function createSearchEventListener(input, suggestions_container) {
  input.addEventListener("input", (e) => {
    const query = e.target.value.trim();

    if (query.length < 0) {
      suggestions_container.innerHTML = "";
      return;
    }

    timeoutId = setTimeout(() => {
      fetchSuggestions(query, suggestions_container);
    }, 300);
  });
}

function fetchSuggestions(query, suggestions_container) {
  const url =
    `/search/suggest.json` +
    `?q=${encodeURIComponent(query)}` +
    `&resources[type]=product` +
    `&resources[limit]=5`;

  fetch(url)
    .then((r) => r.json())
    .then((data) =>
      renderSuggestions(data.resources.results.products, suggestions_container),
    )
    .catch((error) => {
      suggestions_container.innerHTML = "";
    });
}

function renderSuggestions(products, suggestions_container) {
  if (!products.length) {
    suggestions_container.innerHTML = "";
    return;
  }

  suggestions_container.innerHTML = products
    .map((p) => {
      const offer =
        parseFloat(p.compare_at_price_max) > parseFloat(p.price)
          ? `<span class="bg-third text-primary-foreground text-xs px-1 rounded" style="width: fit-content;">Oferta</span>`
          : "";

      const notAvailable = !p.available
        ? `<span class="bg-warning text-warning-foreground text-xs px-1 rounded" style="width: fit-content;">No disponible</span>`
        : "";

      return `
        <a
            class="flex items-center gap-3 p-3 rounded-lg hover:bg-secondary transition-colors group"
            href="${p.url}"
        >
            <img
              src="${p.image}"
              alt="${p.title}"
              class="w-16 h-16 object-cover rounded-md"
            >
            <div class="flex-1 min-w-0">
              <h3
                class="font-medium text-brand-black text-sm mb-1 truncate group-hover:text-primary transition-colors"
              >
                ${p.title}
              </h3>
              <div class="flex items-center gap-2">
                ${notAvailable}
                ${offer}
              </div>
    
            </div>
        </a>
        `;
    })
    .join("");

  // <p class="text-sm font-semibold text-brand-black mt-1">
  //   $ ${p.price}
  //   ${
  //     parseFloat(p.compare_at_price_max) > parseFloat(p.price)
  //       ? `<span class="line-through text-muted-brand-black text-xs ml-2">$ ${p.compare_at_price_max}</span>`
  //       : ""
  //   }
  // </p>
}

function findAllResults() {
  const searchInput = document.getElementById("search-input");
  if (searchInput) {
    window.location.href = "/search?q=" + encodeURIComponent(searchInput.value);
  }
}

document.addEventListener("DOMContentLoaded", () => {
  const searchContainer = document.querySelector("#search-container");
  if (!searchContainer) return;
  const searchInput = searchContainer.querySelector("#search-input");
  const sugestions = searchContainer.querySelector("#suggestions");
  createSearchEventListener(searchInput, sugestions);
});

document.addEventListener("DOMContentLoaded", () => {
  const closeContainer = document.querySelector("#close-search-sidebar");
  if (!closeContainer) return;
  closeContainer.addEventListener("click", () => {
    const searchSidebar = document.querySelector("#search-container");
    if (!searchSidebar) return;
    searchSidebar.classList.add("hidden");
    searchSidebar.classList.remove("fixed");
  });
});
